import { QueryClient } from "@tanstack/react-query";

/**
 * The app's one QueryClient. Shared with the build-time prerender
 * (src/entry-server.tsx), which fills it with a page's public data before
 * rendering, so the prerendered HTML and the browser's first render agree.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute
      gcTime: 5 * 60 * 1000, // 5 minutes (previously cacheTime)
    },
  },
});
